const images = {
  LOGO:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1647449554/logos/CC_logo_-_blue_text_vqbci7.png",
  LOGO_WHITE:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1603737354/logos/corecounts-logo-full_wfsc4e.svg",
  CUSTOM_CORE_VALUE_BADGE:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1605293891/badges/cc-custom-badge_wcaitc.svg",
  MISSION_BADGE:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1604331790/badges/mission_kl0sg8.svg",
  CAMPFIRE:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1604689723/web%20images/cc-campfire_u0fmn2.svg",
  CORE_VALUES:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1603743461/web%20images/cc-core-values-illustration_pjpv7w.svg",
  MISSION:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1603743462/web%20images/cc-mission-illustration_ytzwd5.svg",
  MEMBERS:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1603743462/web%20images/cc-invite-members-illustration_gmlyy2.svg",
  INBOX_MEMBERS:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613165511/web%20images/cc-add-team_qsaajz.svg",
  SURVEY_TEMPLATES:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1603743464/web%20images/cc-survey-templates-illustration_rtb94r.svg",
  WAITING:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1605038021/web%20images/cc-waiting_wxcwhw.svg",
  SURVEY_SCRATCH:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1603743464/web%20images/cc-survey-scratch-illustration_idudlg.svg",
  SURVEY:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1603743464/web%20images/cc-survey-illustration_xm2kmg.svg",
  TRAIN:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1603743465/web%20images/cc-train-illustration_fyjyhc.svg",
  TEAM:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1603743465/web%20images/cc-team-illustration_ibwvdq.svg",
  GROWTH:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1603743462/web%20images/cc-growth-illustration_bg19xp.svg",
  BEHAVIORS:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1604897421/web%20images/cc-behaviors_drhlx1.svg",
  BEHAVIOR_HELP_1:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1606800705/web%20images/cc-survey-preview-behavior.svg_mj7xa5.svg",
  BEHAVIOR_HELP_2:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1606798390/web%20images/cc-behavior-card_fhzkxi.svg",
  CONGRATS:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1606849316/web%20images/cc-congrats_u6vmgn.svg",
  CHECKIN:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1608757138/web%20images/check-in-summery-no-blob_yiwxbc.svg",
  RECOGNITION:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1609866999/web%20images/cc-recognition_e5i38v.svg",
  PERFORMANCE:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1609867217/web%20images/cc-check-in-hub_tk4rta.svg",
  ANNUAL_REVIEW_COREBOARD:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613077326/web%20images/cc-annual-review-coreboard-v2_voi2ia.svg",
  ANNUAL_REVIEW_CHEERS:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613077326/web%20images/cc-annual-review-finish-v2_vvjlpu.svg",
  ANNUAL_REVIEW_RATING:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1611545838/web%20images/cc-employee-rating-graphic_fv2axc.svg",
  ANNUAL_REVIEW_QA:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613077326/web%20images/cc-annual-review-qa-v2_eohdoc.svg",
  SIGNOFF:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1611892103/web%20images/sign-off_rbyhq9.svg",
  CHECKIN_TALKINGPOINTS:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612413259/web%20images/cc-talking-point-checkin_o0n8ia.svg",
  CHECKIN_GOAL:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612413259/web%20images/cc-goal-checkin_cy1sga.svg",
  CHECKIN_ACTIONITEMS:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612413259/web%20images/cc-action-item-checkin_lyn70u.svg",
  CHECKIN_FINISH:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612413259/web%20images/cc-finish-check-in_gtpeqs.svg",
  RECOGNITION_AVATAR:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612450647/web%20images/cc-recognize-five_nemlty.svg",
  DASHBOARD_RECOGNITION:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613426466/web%20images/cc-dashboard-recognition-v3_wimdxn.svg",
  DASHBOARD_CHECKIN:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613426466/web%20images/cc-dashboard-check-in-v3_g9hxhy.svg",
  DASHBOARD_GOALS:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613426467/web%20images/cc-dashboard-goal-v3_a8nhqy.svg",
  DASHBOARD_ACTION_ITEMS:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613426466/web%20images/cc-dashboard-action-item-v3_nx3oo6.svg",
  DASHBOARD_PROFILE:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613426467/web%20images/cc-dashboard-profile-v3_uikhvg.svg",
  DASHBOARD_SURVEYS:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613426466/web%20images/cc-dashboard-survey-v3_lrrqk4.svg",
  DASHBOARD_RESOURCES:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613426468/web%20images/cc-dashboard-resource-v3_tklfg2.svg",
  DASHBOARD_REVIEWS:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613426466/web%20images/cc-dashboard-360-v3_d8gqhu.svg",
  DASHBOARD_COMPANY:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613426466/web%20images/cc-dashboard-company-v3_nygbb1.svg",
  DASHBOARD_SETTINGS:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613426468/web%20images/cc-dashboard-settings-v3_yxvtja.svg",
  DASHBOARD_ANNUAL_REVIEWS:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613425823/web%20images/cc-dashboard-annual-review-v3_tqtlq5.svg",
  DASHBOARD_FEATURE_MANAGEMENT:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613426468/web%20images/cc-dashboard-feature-management-v3_ivppyv.svg",
  AVATAR_MANAGER:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613080538/web%20images/cc-manager-avatar_dxg9sf.svg",
  AVATAR_MEMBER:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613080537/web%20images/cc-employee-avatar_sk5bnd.svg",
  URGENT_TALKING_POINT:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612794401/web%20images/cc-urgent-talking-point_ensboo.svg",
  SELF_ANNUAL_REVIEW:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612798530/web%20images/cc-self-review_pl9gqx.svg",
  ANNUAL_REVIEW_OTHERS:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612798344/web%20images/cc-review-others_pc9ahg.svg",
  OVERDUE:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612797467/web%20images/cc-overdue_gxmxay.svg",
  CHECKIN_REVIEW:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612804569/web%20images/cc-check-in-review_qi9hnn.svg",
  REVIEWS_AVAILABLE:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612799051/web%20images/cc-complete-self-review_t34ff0.svg",
  SURVEY_INCOMPLETE:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612795204/web%20images/cc-survey-incomplete_sdqh2b.svg",
  RESOURCE_INCOMPLETE:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612797030/web%20images/cc-resource-incomplete_mues06.svg",
  SURVEY_RESULTS_IN:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612796524/web%20images/cc-survey-results-in_rc6t6c.svg",
  RESOURCE_VIEWED:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612796745/web%20images/cc-resource-viewed_xzuu6y.svg",
  DUE_DATE_SOON:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612797815/web%20images/cc-due-date-soon_amgfta.svg",
  RECOGNITION_ADDED:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612901170/web%20images/cc-recognition-dashboard_ujrjqg.svg",
  CORE_CARD_NO_DATA:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1612984544/web%20images/cc-card-no-data_ro3lz0.svg",
  CORE_COACH:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1610597024/Front/melissa-500_wvlunk.jpg",
  OVERALL_CORE_CARD_OUTSTANDING:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613597185/web%20images/cc-coreboard-outstanding_ninqgh.svg",
  OVERALL_CORE_CARD_OKAY:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613597185/web%20images/cc-coreboard-okay_ibzgin.svg",
  OVERALL_CORE_CARD_NEEDS_WORK:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613597185/web%20images/cc-coreboard-needs-work_rf3kzr.svg",
  TASK_BACKGROUND:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/co_rgb:{color},o_20,e_colorize:100/v1613744916/web%20images/cc-task-card-shape_vszgrb.png",
  EMPTY_TASK_HUB:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1613795970/web%20images/cc-empty-task-hub_ifnrsb.svg",
  PULSE_START:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/w_85/v1614352074//web%20images/cc-pulse-schedule_eokokq.svg",
  REGISTRATION_ILLUSTRATION:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1632757023/web%20images/cc-signup-illustration_qhukcj.svg",
  INVITE_TEXT:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1633116408/web%20images/cc-invite-employee_dkeg8k.png",
  STAR_ICON:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1633116408/web%20images/cc-stars-icon_gxyaq1.svg",
  SURVEY_COMPLETE:
    "https://res.cloudinary.com/dlw64o4rf/image/upload/v1631825483/web%20images/cc-celebrate-ballons_fsbqm6.svg"
};

export default images;
